@app.directive 'facebookAuthButton', (ModalService, AnalyticsService, $state, $location, authenticationService, $http, $rootScope, csAdwords, csFacebookConversion, formHelper, localStorageService, csConfig, ssoService, $q, $timeout)->
  restrict: 'E'
  scope: {}
  controller: ($scope) ->

    @fbDeferred = undefined

    # This gets called by the fb snippet; must be on window
    window.fbAsyncInit = =>
      FB.init
        appId: csConfig.facebookAppId
        xfbml: true
        version: 'v2.7'

      FB.getLoginStatus (response) =>
        window.fbResponse = {}
        window.fbResponse.user = {}
        if response.status == 'connected'
          window.fbResponse.status = 'connected'
          window.fbResponse.user.user_id = response.authResponse.userID
          window.fbResponse.user.authentication_token = response.authResponse.accessToken
        else if response.status == 'not_authorized'
          window.fbResponse.status = 'not authorized'
        else
          window.fbResponse.status = 'not connected'
        @fbDeferred.resolve(window.fbResponse)

      # This is lovely. On localhost, FB.getLoginStatus() just never calls the response function. So as a
      # stopgap, assume after 5 seconds that we aren't connected. This is never a disaster to assume, we'll just
      # go through FB login again.
      $timeout (=>
        window.fbResponse = {status: 'not connected'} if ! window.fbResponse
        @fbDeferred.resolve(window.fbResponse)
      ), 5000

    fbLazyInit = ->
      # Standard facebook snippet
      `
        (function(d, s, id) {
          console.log("snippet called");
          var fjs, js;
          js = void 0;
          fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = '//connect.facebook.net/en_US/sdk.js';
          fjs.parentNode.insertBefore(js, fjs);
          console.log("snippet end");
        })(document, 'script', 'facebook-jssdk');
      `
      true

    getFacebookResponse = =>
      return @fbDeferred.promise if @fbDeferred

      @fbDeferred = $q.defer()

      if window.fbResponse?
        @fbDeferred.resolve(window.fbResponse)

      else
        fbLazyInit()

      @fbDeferred.promise


    # The following is taken originally from playground
    # The intention is for this to move to cs-shared
    @facebook = =>

      @showSpinner = true


      loginSuccess = (response) =>
        @showSpinner = false
        if @sso
          @state = $location.search().state
          ssoService.signAndRedirect(@state)
        else
          if response.newUser
            # This is questionable - if they are logging in via facebook instead
            # of signing up via facebook, should we really be tracking a conversion?
            # I guess the issue is that, as of now we don't really know whether
            # they were already in the DB - we could pass that back from the server.
            csAdwords.track(998032928,'77TfCIjjrAgQoIzz2wM')
            csFacebookConversion.track(6014798030226,0.00)

            # Mixpanel
            properties = {source : 'modal', method: 'facebook'}
            AnalyticsService.reidentify()
            AnalyticsService.track 'Signed Up JS', properties

            # Google Analytics
            AnalyticsService.track 'Complete', { category: 'Sign Up' }
          if @ftue && response.newUser
            ModalService.resolveSuccess('ftue')
          else
            ModalService.resolveSuccess()

      loginError = (error) =>
        @showSpinner = false
        if error.message == 'User cancelled login or did not fully authorize.'
          @errorMessage = "Please try again. Click 'okay' to allow ChefSteps to sign in with Facebook"

        # TODO Handle situation where a ChefSteps account tries to sign in with Facebook
        # if error.status == 401
        #   ModalService.open('requirePassword', {email: error.user.email})

      getFacebookResponse()
        .then (fbResponse) ->
          authenticationService.loginWithFacebook(fbResponse)
        .then loginSuccess, loginError

    this

  controllerAs: 'facebookAuthButton'
  bindToController: {
    sso: '='
    ftue: '='
  }
  templateUrl: "/assets/templates/directives/ssoForm/facebookAuthButton/facebookAuthButton.html"
